"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _jsxFileName = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/CartIndicator/lib/index.js",
  _templateObject,
  _this = void 0;
function cov_2lsgc22s5t() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/CartIndicator/lib/index.js";
  var hash = "4ea020f46325d211201e86be3134eb600176718a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/CartIndicator/lib/index.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 17
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "2": {
        start: {
          line: 16,
          column: 18
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "3": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "4": {
        start: {
          line: 30,
          column: 0
        },
        end: {
          line: 33,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 22
          },
          end: {
            line: 15,
            column: 23
          }
        },
        loc: {
          start: {
            line: 15,
            column: 47
          },
          end: {
            line: 28,
            column: 1
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 60
          },
          end: {
            line: 18,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 18,
            column: 76
          },
          end: {
            line: 18,
            column: 79
          }
        }, {
          start: {
            line: 18,
            column: 82
          },
          end: {
            line: 18,
            column: 84
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 24,
            column: 20
          },
          end: {
            line: 24,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 24,
            column: 36
          },
          end: {
            line: 24,
            column: 63
          }
        }, {
          start: {
            line: 24,
            column: 66
          },
          end: {
            line: 24,
            column: 83
          }
        }],
        line: 24
      },
      "2": {
        loc: {
          start: {
            line: 25,
            column: 7
          },
          end: {
            line: 25,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 7
          },
          end: {
            line: 25,
            column: 20
          }
        }, {
          start: {
            line: 25,
            column: 24
          },
          end: {
            line: 25,
            column: 67
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4ea020f46325d211201e86be3134eb600176718a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2lsgc22s5t = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2lsgc22s5t();
var CartIcon = (cov_2lsgc22s5t().s[0]++, (0, _styledComponents.default)(_icon.default).attrs({
  className: 'stx-CartIcon'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 24px;\n  height: 24px;\n"]))));
cov_2lsgc22s5t().s[1]++;
var CartIndicator = function CartIndicator(_ref) {
  var indicator = _ref.indicator,
    intl = _ref.intl;
  cov_2lsgc22s5t().f[0]++;
  var message = (cov_2lsgc22s5t().s[2]++, {
    cartIndicatorAltMsg: intl.formatMessage({
      id: "gravity.cartIndicator.cartIcon.altText.product".concat(indicator > 1 ? (cov_2lsgc22s5t().b[0][0]++, 's') : (cov_2lsgc22s5t().b[0][1]++, ''))
    }, {
      indicator: indicator
    }),
    cartTitle: intl.formatMessage({
      id: 'gravity.TsHeader.cartTitle'
    })
  });
  cov_2lsgc22s5t().s[3]++;
  return /*#__PURE__*/_react.default.createElement("span", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(CartIcon, {
    iconName: "cart",
    className: "stx-CartIndicator",
    "aria-label": indicator > 0 ? (cov_2lsgc22s5t().b[1][0]++, message.cartIndicatorAltMsg) : (cov_2lsgc22s5t().b[1][1]++, message.cartTitle),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }), (cov_2lsgc22s5t().b[2][0]++, indicator > 0) && (cov_2lsgc22s5t().b[2][1]++, /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": "true",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 25
    }
  }, indicator)));
};
cov_2lsgc22s5t().s[4]++;
CartIndicator.propTypes = {
  indicator: _propTypes.default.number.isRequired,
  intl: _reactIntl.intlShape.isRequired
};
var _default = exports.default = (0, _reactIntl.injectIntl)(CartIndicator);